export const allowedGrantTypeOptions = [
  { labelText: '確認コード', value: 'authorization_code' },
  { labelText: 'リフレッシュトークン', value: 'refresh_token' },
  { labelText: 'デリゲーションコード', value: 'urn:pokepay:delegation-code' },
  {
    labelText: 'トークンエクスチェンジ',
    value: 'urn:ietf:params:oauth:grant-type:token-exchange',
  },
];

// 新規登録するクライアントはほぼ全てこの 2 つの組み合わせなので、登録画面の初期選択にする
export const defaultAllowedGrantTypes = ['authorization_code', 'refresh_token'];

export const defaultScopeOptions = [
  { labelText: 'マネー(Read)', value: 'private_money:read' },
  { labelText: 'マネー(Write)', value: 'private_money:write' },
];

// 未選択で登録するとサーバが両方を付けるので、画面も同じ状態から始める
export const defaultDefaultScopes = ['private_money:read', 'private_money:write'];

export const creatingAccountTypeOptions = [
  { label: 'アカウントを作らない', value: 'none' },
  { label: 'デフォルトマネーのアカウントを作成する', value: 'one' },
  { label: '発行体の全てのマネーのアカウントを作る', value: 'all' },
];

export const concealUserExistenceOptions = [
  { label: '常に隠す', value: 'always' },
  { label: '新規登録時のみ隠す', value: 'register' },
  { label: 'ログイン時のみ隠す', value: 'login' },
  { label: '隠さずエラーにする', value: 'never' },
];
